import * as Service from 'types/service';
import { getCommunicatorsByTopic } from 'utils/service/localStorageUtils';
import { todayBusinessDay } from '@tock/shared/utils/time';
import _ from 'lodash';

export function constructTopicString(businessId: number, serviceDate: string): string {
  return `${businessId}:${serviceDate}`;
}

export function constructTopic(topic: Service.Topic) {
  return constructTopicString(topic.selectedBusiness.id, topic.serviceDate);
}

export function getExistingCommunicatorForTopic(
  topic: Service.Topic
): Service.Communicator | undefined {
  const communicatorsByTopic = getCommunicatorsByTopic();
  if (!communicatorsByTopic) {
    return undefined;
  }
  return communicatorsByTopic[constructTopic(topic)];
}

export function getInitialTopic(
  authenticatedForBusinesses: Service.MassagedBusiness[],
  currentBusiness: Service.MassagedBusiness,
  communicators: {
    [topicKey: string]: Service.Communicator;
  },
  desiredDate?: string,
  legacyCommunicator?: Service.Communicator
): { initialTopic?: Service.Topic; relevantCommunicator?: Service.Communicator } {
  const today = todayBusinessDay().toString();
  const desiredTopic = {
    everConnected: false,
    selectedBusiness: currentBusiness,
    serviceDate: desiredDate || today,
  };
  const businessMatchingDesiredTopic = _.find(authenticatedForBusinesses, (business) => {
    return (
      desiredTopic &&
      desiredTopic.selectedBusiness &&
      business.id === desiredTopic.selectedBusiness.id
    );
  });
  if (!businessMatchingDesiredTopic) {
    return { initialTopic: undefined, relevantCommunicator: undefined };
  }

  const topicKeyForDesiredTopic = constructTopic(desiredTopic);
  const relevantCommunicator = communicators[topicKeyForDesiredTopic] || legacyCommunicator;

  // Refresh the roles of the selected business in case the user changed
  desiredTopic.selectedBusiness.roles = businessMatchingDesiredTopic.roles;

  return {
    initialTopic: desiredTopic,
    relevantCommunicator,
  };
}
